/**
 * Price utility with promotional period support
 * Configure via: REACT_APP_MONEY, REACT_APP_PROMO_PRICE, REACT_APP_PROMO_START, REACT_APP_PROMO_END
 * Date format: DD/MM/YYYY | Timezone: Europe/Copenhagen (GMT+1)
 */

const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.split('/');
  if (parts.length !== 3) return null;
  const [day, month, year] = parts.map(Number);
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  return new Date(year, month - 1, day);
};

const isInPromoPeriod = (denmarkTime, startDate, endDate) => {
  const currentDate = new Date(denmarkTime.getFullYear(), denmarkTime.getMonth(), denmarkTime.getDate());
  return currentDate >= startDate && currentDate <= endDate;
};

export const getPrice = () => {
  const regularPrice = parseFloat(process.env.REACT_APP_MONEY) || 295;
  const promoPrice = parseFloat(process.env.REACT_APP_PROMO_PRICE) || regularPrice;
  const promoStart = process.env.REACT_APP_PROMO_START || '';
  const promoEnd = process.env.REACT_APP_PROMO_END || '';

  if (!promoStart || !promoEnd) return regularPrice;

  const startDate = parseDate(promoStart);
  const endDate = parseDate(promoEnd);
  if (!startDate || !endDate) return regularPrice;

  const now = new Date();
  const denmarkTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));

  return isInPromoPeriod(denmarkTime, startDate, endDate) ? promoPrice : regularPrice;
};

export const getFormattedPrice = () => {
  const price = getPrice();
  return price.toLocaleString('da-DK', { minimumFractionDigits: price % 1 !== 0 ? 2 : 0 });
};

export const isPromoPeriod = () => {
  const promoStart = process.env.REACT_APP_PROMO_START || '';
  const promoEnd = process.env.REACT_APP_PROMO_END || '';

  if (!promoStart || !promoEnd) return false;

  const startDate = parseDate(promoStart);
  const endDate = parseDate(promoEnd);
  if (!startDate || !endDate) return false;

  const now = new Date();
  const denmarkTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));

  return isInPromoPeriod(denmarkTime, startDate, endDate);
};

export default getPrice;
